import { render, staticRenderFns } from "./ChartJsWidget.vue?vue&type=template&id=3123e9bf"
import script from "./ChartJsWidget.vue?vue&type=script&lang=js"
export * from "./ChartJsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports